import { IMedia, isMedia } from '../types';
import { eachValue } from './eachValue';

export function eachMedia(item: unknown, callback: (value: IMedia) => void) {
  eachValue(item, (value) => {
    if (isMedia(value)) {
      callback(value);
    }
  });
}
